import React from 'react';
import Lightbox from 'react-images';

class Tile extends React.Component {
	constructor(props) {
			super(props);
			this.state = {
				width: window.innerWidth,
				open: false,
                mouseOver: false,
                lightboxIsOpen: false
			};
			// Bind properties to class instance
			this._clickHandler = this._clickHandler.bind(this);
			this._mouseEnter = this._mouseEnter.bind(this);
            this._mouseLeave = this._mouseLeave.bind(this);
            this.closeLightbox = this.closeLightbox.bind(this);
		}
		componentWillMount() {
			window.addEventListener('resize', this.handleWindowSizeChange);
			window.addEventListener('scroll', this.handleScroll);
			document.addEventListener('mousedown', this.handleClickOutside);
		}
		  
		componentWillUnmount() {
			window.removeEventListener('resize', this.handleWindowSizeChange);
			window.removeEventListener('scroll', this.handleScroll);
			document.removeEventListener('mousedown', this.handleClickOutside);
		}
		  
		handleWindowSizeChange = () => {
			this.setState({ width: window.innerWidth });
		}


		// Event handlers to modify state values
	_mouseEnter(e) {
		e.preventDefault();
		if (this.state.mouseOver === false) {
			//console.log(this.props.data.name);
			this.setState({
				mouseOver: true
			})
		}
	}
	_mouseLeave(e) {
		e.preventDefault();
		if (this.state.mouseOver === true) {
			this.setState({
				mouseOver: false
			})
		}
	}
	_clickHandler(e) {
		e.preventDefault();
		if (this.state.open === false) {
			this.setState({
                open: true,
                lightboxIsOpen : true
			});
		} else {
			this.setState({
                open: false,
                lightboxIsOpen: false
			});
        }
        
    }
    
    closeLightbox(e)
    {
        this.setState({
            open: false,
            lightboxIsOpen: false
        });
    }

	render() {
		// Modify styles based on state values
		let tileStyle = {};

		let moblieTileStyle = {};

        let imagedata = [{'src': this.props.data.image}];
		// When tile clicked
		
			tileStyle = {
				width: '30vw',
				height: '30vw'
		}

		moblieTileStyle= {
			width: '60vw',
				height: '60vw'
		}
		const { width } = this.state;
		const isMobile = width <= 991;
		let tile = {};
		if(isMobile)
		{
		tile=	(<div>
			<Lightbox images={imagedata} isOpen={this.state.lightboxIsOpen} showImageCount={false} onClose={this.closeLightbox}/>
		<div className="tile" style={{width:'60vw', height:'60vw'}}>
			<img
				onMouseEnter={this._mouseEnter}
				onMouseLeave={this._mouseLeave}
				onClick={this._clickHandler}
				src={this.props.data.image}
				alt={this.props.data.name}
				style={moblieTileStyle}
			/>
		</div>
		</div>);
		}
		else
		{

		tile=(<div>
			<Lightbox images={imagedata} isOpen={this.state.lightboxIsOpen} showImageCount={false} onClose={this.closeLightbox}/>
		<div className="tile">
			<img
				onMouseEnter={this._mouseEnter}
				onMouseLeave={this._mouseLeave}
				onClick={this._clickHandler}
				src={this.props.data.image}
				alt={this.props.data.name}
				style={tileStyle}
			/>
		</div>
		</div>);
		}
		return (
			<div>
		   {tile}
		   </div>
		);
	}
}

export default Tile;


// WEBPACK FOOTER //
// ./src/components/Tile.js